import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "StressBreathEditor"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15 3C17.0711 3 18.75 4.67893 18.75 6.75C18.75 8.82107 17.0711 10.5 15 10.5C12.9289 10.5 11.25 8.82107 11.25 6.75C11.25 4.67893 12.9289 3 15 3ZM15 1.5C12.1005 1.5 9.75 3.85051 9.75 6.75C9.75 9.6495 12.1005 12 15 12C17.8995 12 20.25 9.6495 20.25 6.75C20.25 3.85051 17.8995 1.5 15 1.5ZM22.5 22.5H21V18.75C21 16.6789 19.3211 15 17.25 15H12.75C10.6789 15 9 16.6789 9 18.75V22.5H7.5V18.75C7.5 15.8505 9.8505 13.5 12.75 13.5H17.25C20.1495 13.5 22.5 15.8505 22.5 18.75V22.5ZM8.25 6H3.75C2.50736 6 1.5 4.99264 1.5 3.75V2.25H3V3.75C3 4.16421 3.33579 4.5 3.75 4.5H8.25V6ZM3 11.25H1.5V9.75C1.5 8.50736 2.50736 7.5 3.75 7.5H8.25V9H3.75C3.33579 9 3 9.33579 3 9.75V11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/StressBreathEditor.vue"]]);
